import { Navigate, useLocation } from 'react-router-dom';

export const PrivateWrapper = ({ children }) => {
  const localStorageToken = localStorage.getItem('access_token');
  const isLoggedIn = localStorageToken !== null;

  const location = useLocation();

  // let isAuthenticated = false;
  // if(localStorageToken !== null) { //without remember check storage
  //     isAuthenticated = true;
  // } else if(cookieToken?.access_token || localStorageToken) { //with remember me check
  //     localStorage.setItem('access_token', cookieToken.access_token);
  //     localStorage.setItem('refresh_token', cookieToken.refresh_token);
  //     isAuthenticated = true;
  // }
  // return isAuthenticated ? children : <Navigate to="/login" />;

  return !isLoggedIn ? <Navigate state={{ from: location.pathname }} to={'/login'} /> : children;
};
